<template>
  <main class="search-container" @touchmove.prevent>
    <!-- 搜索框 -->
    <souhuo-search
      ref="searchInputTmpl"
      :searchTig="searchTig"
      :inputShowed="true"
      :searchText="searchText"
      @hideInput="hideInput"
      @searchResult="searchResult"
    >
    </souhuo-search>
    <template>
      <div class="search_data_box">
        <div class="search_main" v-if="historySearchData.length > 0">
          <div class="t_999 s_title">
            <i class="iconfont icon-sousuo" size="14"></i>
            <span>历史搜索</span>
            <i
              class="icon-delete iconfont icon-garbage"
              @click="deleteHistorySearch"
            ></i>
          </div>
          <div class="s_tags">
            <div v-for="(item, index) in historySearchData" :key="index">
              <div class="s_tag" @click="goSearchResult(item)">{{ item }}</div>
            </div>
          </div>
        </div>
        <div class="search_main" v-if="hotSearchData.length !== 0">
          <div class="t_999 s_title">
            <i class="icon-icon-test1 iconfont" size="14"></i>
            <span>热门搜索</span>
          </div>
          <div class="s_tags">
            <div v-for="(item, index) in hotSearchData" :key="index">
              <div class="s_tag" @click="goSearchResult(item)">{{ item }}</div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </main>
</template>

<script>
import souhuoSearch from "@/components/common/souhuoSearch/SouhuoSearch";
import {
  GetHistoricalSearch,
  NoAuthGetHistoricalSearch,
  NoAuthGetHotSearch,
  DeleteHistoricalSearch,
  NoAuthDeleteHistoricalSearch,
} from "@/api/search";
import { Indicator, Toast, MessageBox } from "mint-ui";
export default {
  data() {
    return {
      historySearchData: [],
      hotSearchData: [],
      searchText: "",
      searchTig: "",
    };
  },
  components: {
    souhuoSearch,
  },
  props: {
    querySearch: {
      type: String,
      default: "",
    },
  },
  mounted() {
    this.searchText = this.querySearch;
    this.fetchData();
  },
  methods: {
    fetchData() {
      let loginState = this.$store.getters.loginState;
      if (loginState) {
        this.fetchHistoryData();
        this.fetchHotData();
      } else {
        this.fetchNoAuthHistoryData();
        this.fetchHotData();
      }
    },
    goSearchResult(item) {
      this.searchText = item;
      this.$emit("goSearchResult", this.searchText);
    },
    searchResult(inputVal) {
      this.$emit("searchResult", inputVal);
    },
    hideInput() {
      this.$emit("hideInput");
    },
    // 历史搜索
    fetchHistoryData() {
      Indicator.open({
        text: "加载中",
        spinnerType: "triple-bounce",
      });
      GetHistoricalSearch()
        .then((res) => {
          this.historySearchData = res;
          Indicator.close();
        })
        .catch((res) => {
          Indicator.close();
          if (res.ErrMsg) {
            Toast(res.ErrMsg);
          }
        });
    },
    // 未登录情况下，获取历史搜索记录
    fetchNoAuthHistoryData() {
      Indicator.open({
        text: "加载中",
        spinnerType: "triple-bounce",
      });
      NoAuthGetHistoricalSearch()
        .then((res) => {
          this.historySearchData = res;
          Indicator.close();
        })
        .catch((res) => {
          Indicator.close();
          if (res.ErrMsg) {
            Toast(res.ErrMsg);
          }
        });
    },
    // 热门搜索
    fetchHotData() {
      Indicator.open({
        text: "加载中",
        spinnerType: "triple-bounce",
      });
      NoAuthGetHotSearch()
        .then((res) => {
          Indicator.close();
          this.hotSearchData = res;
          this.searchTig = res[0];
        })
        .catch((res) => {
          Indicator.close();
          if (res.ErrMsg) {
            Toast(res.ErrMsg);
          }
        });
    },
    // 清空历史搜索
    deleteHistorySearch() {
      let loginState = this.$store.getters.loginState;
      MessageBox({
        title: "提示",
        message: "确认删除全部历史记录？",
        showCancelButton: true,
        confirmButtonClass: "t_f23030",
      }).then((action) => {
        if (action === "confirm") {
          Indicator.open({
            text: "加载中",
            spinnerType: "triple-bounce",
          });
          if (loginState) {
            this.DeleteHistoricalSearch();
          } else {
            this.NoAuthDeleteHistoricalSearch();
          }
        }
      });
    },
    // 登录情况下，清除历史搜索记录
    DeleteHistoricalSearch() {
      DeleteHistoricalSearch()
        .then((res) => {
          Indicator.close();
          this.historySearchData = [];
        })
        .catch((res) => {
          Indicator.close();
          if (res.ErrMsg) {
            if (res.ErrMsg) {
              Toast(res.ErrMsg);
            }
          }
        });
    },
    // 未登录情况下，清除历史搜索记录
    NoAuthDeleteHistoricalSearch() {
      NoAuthDeleteHistoricalSearch()
        .then((res) => {
          Indicator.close();
          this.historySearchData = [];
        })
        .catch((res) => {
          Indicator.close();
          if (res.ErrMsg) {
            Toast(res.ErrMsg);
          }
        });
    },
  },
};
</script>
<style>
.mint-search {
  height: auto;
}
.search .mint-search .mint-searchbar {
  background-color: #fff;
}
.search .mint-searchbar-inner {
  border: 1px solid #f23030;
  border-radius: 5px;
  box-sizing: border-box;
}
.search .mint-searchbar-cancel {
  color: #f23030;
}
.search .mintui-search {
  font-size: 10px;
  margin: 0 6px;
}
.search .mint-searchbar-cancel {
  display: block !important;
}
.mint-search-list {
  display: none !important;
}
.search_data_box {
  margin-top: 8px;
}
</style>
<style scoped>
.search-container {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: #fff;
  z-index: 110;
  font-size: 14px;
}
.search {
  box-shadow: 0 4px 6px 3px rgba(0, 0, 0, 0.04);
}
.search_main {
  padding: 10px 0 15px 15px;
  background: #fff;
  border-bottom: 1px solid #f2f2f2;
}
.search_main:last-child {
  border-bottom: none;
}
.s_title {
  position: relative;
  font-size: 15px;
  color: #999;
  display: flex;
  align-items: center;
}
.s_title i {
  margin-right: 8px;
  display: inline-block;
}
.s_title .icon-delete {
  position: absolute;
  top: 0;
  right: 0;
  display: block;
  font-size: 19px;
  cursor: pointer;
  margin-right: 10px;
}
.s_tags {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.s_tags > div {
  max-width: 100%;
}
.s_tag {
  padding: 5px 10px;
  background: #f2f2f2;
  border-radius: 30px;
  margin-right: 15px;
  margin-top: 10px;
  font-size: 14px;
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
